import styled from "styled-components/macro";
import { StyledButton } from "../../components/shared/Button/Button.styles";
import { StyledTypography } from "../../components/shared/Typography/Typography.styles";

export const CfcWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CfcContentWrapper = styled.div`
  align-items: start;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 805px 343px;
  column-gap: 34px;
  max-width: 1182px;
  padding: 48px 0 60px;
  width: 100%;

  @media (max-width: 1200px) {
    grid-template-columns: 100%;
    justify-items: center;
    row-gap: 14px;
    padding: 60px 24px 112px 24px;
  }

  @media (max-width: 600px) {
    padding: 24px 0px 32px 0px;
  }
`;

export const CfcBackToResults = styled.button`
  align-items: flex-end;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.redMedium};
  cursor: pointer;
  display: flex;
  gap: 4px;
  height: 48px;
  margin: 0;
  padding: 0 10px;
  width: fit-content;

  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.redDark};
    outline-offset: 2px;
  }
`;

export const CfcTitleWrapper = styled.div`
  display: grid;

  @media (min-width: 1201px) {
    padding-left: 16px;
    padding-top: 24px;
  }
`;

export const CfcPageTitle = styled.h1`
  color: ${({ theme }) => theme.greyMedium};
  font-family: bold;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 34px;
  margin: 0;
`;

export const CfcSubtitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    color: ${({ theme }) => theme.greyMedium};
    height: 18px;
    width: 18px;
  }
`;

export const CfcMainColumn = styled.div`
  align-content: start;
  display: grid;
  width: 805px;

  @media (max-width: 1200px) {
    grid-template-columns: 100%;
    justify-items: center;
    row-gap: 14px;
    width: 100%;
    max-width: 570px;
  }

  @media (max-width: 600px) {
    max-width: 360px;
  }

  ${CfcBackToResults},
  ${CfcTitleWrapper} {
    @media (max-width: 1200px) {
      justify-self: start;
      width: 100%;
    }
  }

  ${CfcTitleWrapper} {
    @media (max-width: 1200px) {
      padding-left: 16px;
    }
  }

  ${CfcBackToResults} {
    @media (max-width: 1200px) {
      margin-left: 10px;
      padding: 0;
    }
  }
`;

export const CfcSupportColumn = styled.div`
  display: grid;
  align-content: start;
  row-gap: 12px;
  padding-top: 150px;
  width: 343px;

  @media (max-width: 1200px) {
    padding-top: 0;
    row-gap: 0;
    width: 100%;
    max-width: 570px;
  }

  @media (max-width: 600px) {
    max-width: 360px;
  }
`;

export const CfcGeneralContainer = styled.div`
  box-sizing: border-box;
  padding: 24px 20px;
  background-color: ${({ theme }) => theme.white};
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: 20px;
  width: 100%;

  @media (max-width: 1200px) {
    margin-top: 20px;
    padding: 20px;
    max-width: 802px;
    width: auto;
  }
`;

export const CfcResultCard = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-gap: 24px;
  background-color: ${({ theme }) => theme.white};
  border-radius: 20px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  margin-top: 20px;
  padding: 24px 20px;
  width: 100%;

  @media (max-width: 600px) {
    margin-top: 0;
    max-width: 360px;
  }
`;

export const CfcResultCardTitle = styled.h2`
  color: ${({ theme }) => theme.greyMedium};
  font-family: caps;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
  text-transform: uppercase;
`;

export const CfcResultStatusRow = styled.div`
  display: grid;
  grid-template-columns: 32px auto;
  align-items: center;
  color: ${({ theme }) => theme.greyMedium};
  column-gap: 16px;
  min-height: 40px;

  ${StyledTypography} {
    font-size: 24px;
    line-height: 30px;
  }

  svg {
    height: 24px;
    width: 24px;
  }
`;

export const CfcReportButton = styled(StyledButton)`
  && {
    width: 247px;
    height: 45px;
  }

  > div {
    gap: 10px;
    margin: 0;
  }

  ${StyledTypography} {
    font-size: 21px;
    letter-spacing: 0.42px;
    line-height: 20px !important;
    white-space: nowrap;
  }

  svg {
    height: 15px;
    width: 15px;
  }

  @media (max-width: 600px) {
    && {
      width: 226px;
      height: 40px;
    }
  }
`;
